import { ApiError } from "../../../lib/api.js";

/**
 * The signed-in user's profile shape + the small response/error helpers,
 * extracted from `ProfilePage.tsx` so the cards share one definition and the
 * pure helpers unit-test directly.
 */
export interface ProfileUser {
  id: number;
  email: string;
  first_name: string | null;
  last_name: string | null;
  full_name: string | null;
  role: string | null;
  two_factor_enabled: boolean;
  two_factor_method?: string | null;
}

/** Accept any of the envelope shapes portal-api may use (`{data}`, `{user}`,
 * or the bare object) and return the profile. */
export function unwrap(resp: unknown): ProfileUser {
  const r = resp as Record<string, unknown>;
  return (r.data ?? r.user ?? r) as ProfileUser;
}

/** A typed `ApiError`'s message, else the fallback. */
export function errMsg(e: unknown, fallback: string): string {
  return e instanceof ApiError ? e.message : fallback;
}
